import { render } from "./FeatsView.vue?vue&type=template&id=29481fdf&scoped=true"
import script from "./FeatsView.vue?vue&type=script&lang=js"
export * from "./FeatsView.vue?vue&type=script&lang=js"

import "./FeatsView.vue?vue&type=style&index=0&id=29481fdf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29481fdf"]])

export default __exports__